import React from 'react';
import { NavLink } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class MonitoringHeader extends React.Component {
    render() {
        return (<>
            <MainHeader label="Monitorng.Common.PortfolioManagementAndMonitoring" shadowed={false} {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${this.isActiveLink('portfolioOverview') || this.isActiveLink('editPortfolio') ? "is-active" : ""}`}>
                        <NavLink to={`${this.props.match.url}/portfolioOverview`}>
                            <Translate id='Monitoring.Common.PortfolioOverview' />
                        </NavLink>
                        <div className="search-progress-short"
                            style={{ display: this.isActiveLink('portfolioOverview') || this.isActiveLink('editPortfolio') ? "" : "none" }} />
                    </li>
                    <li className={`tab-link ${this.isActiveLink('alerts') ? "is-active" : ""}`}>
                        <NavLink to={`${this.props.match.url}/alerts`}>
                            <Translate id='Monitoring.Common.Alerts' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: this.isActiveLink('alerts') ? "" : "none" }}></div>
                    </li>
                </ul>
            </div>}
        </>)
    }

    isActiveLink(item) {
        return this.props.location.pathname.indexOf(item) >= 0;
    }
}

export default withRouter(MonitoringHeader);